import Head from 'next/head'

import type { FC, ReactNode } from 'react'
import type { SeoProps } from '@/types'

import { useSettings } from '@/components/providers/settings-provider'
import { siteConfig } from '@/constants/site'

export const Seo: FC<SeoProps> = ({
    title,
    description = siteConfig.description,
    ogImage
}): ReactNode => {
    const settings = useSettings()
    const siteName = settings.storeName || siteConfig.name
    const pageTitle = title ? `${title} - ${siteName}` : siteName
    // Without a page image, share the official logo as a square preview.
    const image = ogImage || settings.logo

    return (
        <Head>
            <title>
                {pageTitle}
            </title>

            <meta name='description' content={description} />
            <meta property='og:title' content={pageTitle} />
            <meta property='og:description' content={description} />
            <meta property='og:type' content='website' />
            <meta property='og:locale' content='id_ID' />
            <meta property='og:site_name' content={siteName} />
            {siteConfig.url && <meta property='og:url' content={siteConfig.url} />}
            <meta name='twitter:card' content={ogImage ? 'summary_large_image' : 'summary'} />
            <meta name='twitter:title' content={pageTitle} />
            <meta name='twitter:description' content={description} />

            {image && <meta property='og:image' content={image} />}
            {image && <meta name='twitter:image' content={image} />}
        </Head>
    )
}
